import React from "react";
import textConfig from "../utils/text";

/**
 * Frame 18
 * @param props
 * @constructor
 */
export default function Frame18(props: any){
	
	let {  Svg, svgProps, children, viewBox, backgroundColor, frameBody } = props;
	let { path, text_1 } = props, [ __html, { textColor, style } ] = textConfig(text_1, frameBody);
	
		return <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...svgProps}
		            viewBox="0 0 1381 1286" fill="none">
			
			<defs>
				<clipPath id="clip0_236_4">
					<rect width="1380.92" height="1286" fill="white"/>
				</clipPath>
				<clipPath id="myClip">
					<rect width="1000" height="1000" rx="20" fill="none"/>
				</clipPath>
			</defs>
			<g clipPath="url(#clip0_236_4)">
				<path
					d="M1041.75 0C1048.11 -0.00024662 1054.41 1.25264 1060.29 3.6875C1066.17 6.12234 1071.51 9.69126 1076.01 14.1904C1080.51 18.6897 1084.08 24.0315 1086.51 29.9102C1088.95 35.7889 1090.2 42.09 1090.2 48.4531V169.586C1090.01 171.224 1090.18 172.884 1090.72 174.442C1091.26 176.001 1092.15 177.417 1093.32 178.583C1094.48 179.749 1095.9 180.636 1097.46 181.176C1099.01 181.716 1100.68 181.894 1102.31 181.699H1332.47C1345.32 181.699 1357.64 186.804 1366.73 195.891C1375.81 204.977 1380.92 217.302 1380.92 230.152V666.232C1380.92 679.083 1375.81 691.407 1366.73 700.493C1357.64 709.58 1345.32 714.685 1332.47 714.685H1102.31C1100.67 714.49 1099.01 714.669 1097.46 715.209C1095.9 715.749 1094.48 716.635 1093.31 717.802C1092.15 718.968 1091.26 720.385 1090.72 721.943C1090.18 723.502 1090 725.162 1090.2 726.8V1041.75C1090.2 1048.11 1088.95 1054.41 1086.51 1060.29C1084.08 1066.17 1080.51 1071.51 1076.01 1076.01C1071.51 1080.51 1066.17 1084.08 1060.29 1086.51C1054.41 1088.95 1048.11 1090.2 1041.75 1090.2H48.4531C42.09 1090.2 35.7889 1088.95 29.9102 1086.51C24.0315 1084.08 18.6897 1080.51 14.1904 1076.01C9.69126 1071.51 6.12234 1066.17 3.6875 1060.29C1.25264 1054.41 -0.000246619 1048.11 0 1041.75V48.4531C0 35.6026 5.10471 23.2781 14.1914 14.1914C23.2781 5.10471 35.6026 0 48.4531 0H1041.75ZM74 54C62.9543 54 54 62.9543 54 74V1014C54 1025.05 62.9543 1034 74 1034H1014C1025.05 1034 1034 1025.05 1034 1014V74C1034 62.9543 1025.05 54 1014 54H74ZM1113 243C1107.48 243 1103 247.477 1103 253V644C1103 649.523 1107.48 654 1113 654H1310C1315.52 654 1320 649.523 1320 644V253C1320 247.477 1315.52 243 1310 243H1113Z"
					fill={frameBody}/>
				<path
					d="M54 74C54 62.9543 62.9543 54 74 54H1014C1025.05 54 1034 62.9543 1034 74V1014C1034 1025.05 1025.05 1034 1014 1034H74C62.9543 1034 54 1025.05 54 1014V74Z"
					fill={backgroundColor}/>
				<path
					d="M1103 253C1103 247.477 1107.48 243 1113 243H1310C1315.52 243 1320 247.477 1320 253V644C1320 649.523 1315.52 654 1310 654H1113C1107.48 654 1103 649.523 1103 644V253Z"
					fill={backgroundColor}/>
				<path d="M1308 291H1115V581H1308V291Z" fill={frameBody}/>
				<path d="M1236 266H1188V279H1236V266Z" fill={frameBody}/>
				<path
					d="M1214.5 599.61H1208.16C1199.88 599.61 1193.16 606.326 1193.16 614.61V620.95C1193.16 629.234 1199.88 635.95 1208.16 635.95H1214.5C1222.79 635.95 1229.5 629.234 1229.5 620.95V614.61C1229.5 606.326 1222.79 599.61 1214.5 599.61Z"
					fill={frameBody}/>
				<path
					d="M1259.79 423.966L1247.67 411.853L1223.45 436.08V375.513H1199.22V436.08L1174.99 411.853L1162.88 423.966L1211.33 472.419L1259.79 423.966ZM1259.79 472.419V496.646H1162.88V472.42H1150.77V508.76H1271.9V472.42L1259.79 472.419Z"
					fill={backgroundColor}/>
			</g>
			<g transform="translate(54 54) scale(0.98)">
				<g clipPath="url(#myClip)">{children}</g>
			</g>
			<g transform={"translate(50 1086) scale(1)"}>
				<svg xmlns="http://www.w3.org/2000/svg" width={1000} height={200} viewBox={viewBox}>
					<defs>
						<clipPath id="myClip">
							<path d={path}/>
						</clipPath>
					</defs>
					<foreignObject x="0" y="0" width="1000" height="200" clipPath="url(#myClip)">
						<div
							dangerouslySetInnerHTML={{__html}}
							style={{
								width: 'calc(100%)', height: 'calc(100%)',
								display: 'flex', justifyContent: 'center', alignItems: 'center',
								...style, color: frameBody
							}}
						/>
					</foreignObject>
				</svg>
			</g>
		
		</Svg>
}